// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"ca83a395","133":"3d0f3ac0","182":"b31d7f6d"}[chunkId] + ".chunk.js";
};